import { camelCase } from 'lodash';
import { Content, Node, NodeText } from 'posthtml-parser';

export const isTextNode = (node: Node | Content): node is NodeText =>
  ['string', 'number'].includes(typeof node);

export const isComment = (node: Node) =>
  node.toString().trim().startsWith('<!');

export const parseStyleString = (styleString: string): React.CSSProperties => {
  const styleObject: React.CSSProperties = {};
  styleString.split(';').forEach((style) => {
    const [key, value] = style.split(/:(?!\/)/gimu);
    if (key && value) {
      const camelCaseKey = camelCase(key);
      // @ts-expect-error
      styleObject[camelCaseKey] = value.trim();
    }
  });
  return styleObject;
};
